import clsx from 'clsx'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '@hooks/useLanguage'

// the site's languages, each named in itself
export const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'ru', label: 'Русский' },
  { value: 'uk', label: 'Українська' },
]

// The site language as the system's segmented control: three buttons, the
// chosen one pressed. The phone's profile menu and the desktop sidebar share
// it (the sidebar had its own dropdown with 32px rows and no pressed state).
const LanguageSegments: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()
  const { language, setLanguage } = useLanguage()
  return (
    <div
      role="group"
      aria-label={t('language')}
      className={clsx('flex gap-1 p-1 h-11 rounded-xl bg-track', className)}
    >
      {[...languageOptions].reverse().map((option) => (
        <button
          key={option.value}
          type="button"
          lang={option.value}
          aria-pressed={language === option.value}
          onClick={() => setLanguage(option.value)}
          className={clsx(
            'flex-1 min-w-0 px-1 rounded-[0.5625rem] text-sm truncate transition-colors duration-200',
            language === option.value
              ? 'bg-raised font-extrabold text-ink shadow-[0_1px_4px_rgba(33,36,48,0.12)]'
              : 'font-bold text-muted hover:text-ink',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default LanguageSegments
